// extracted by mini-css-extract-plugin
export default {"container":"components-DynamicPage-styles-module__container--nc_PT"};